export default {
  selectAllLabel: 'Select All',
};
